import { useSearch } from '@tanstack/react-router'
import { DEFAULT_ORGANIZATION_ID } from '../components/overview/channel-filter'

export const useOrganizationId = (): number => {
    const search = useSearch({ from: '/_app/playbook' })
    return (search.organizationId as number | undefined) ?? DEFAULT_ORGANIZATION_ID
}
